<template>
  <omni-channel-process v-if="omniAccess" />
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import OmniChannelProcess from "./OmniChannelProcess.vue";

export default {
  components: {
    OmniChannelProcess,
  },
  data() {
    return {
      isOpen: false,
      omniConverse: [],
      assistantOpen: false,
      omniNotificationTimer: null,
      assistantConverse: [],
      omniExpansionValue: "open_converse",
    };
  },
  computed: {
    ...mapGetters([
      "inCall",
      "phonePermission",
      "agentStatusPermission",
      "omniChannelPermission",
      "ManageOmniChannelPermission",
      "permissions",
      "notReadOmniMessages",
      "omniActiveConversations",
      "omniOpenedConversation",
      "assistantAsk",
      "assistantChat",
    ]),
    currentLocal() {
      return this.$vuetify.locale.current;
    },
    omniAccess() {
      return (
        this.userHasPermisson(this.permissions, this.omniChannelPermission) ||
        this.userHasPermisson(
          this.permissions,
          this.ManageOmniChannelPermission
        )
      );
    },
    assistantPosition() {
      // console.log("My assistantPosition:::", this.omniConverse);
      if (this.isOpen) {
        if (this.omniConverse?.length > 0 && this.omniOpenedConversation) {
          return this.currentLocal == "ar"
            ? "assist-open-ar"
            : "assist-open-en";
        } else if (
          this.omniConverse?.length > 0 &&
          !this.omniOpenedConversation
        ) {
          return this.currentLocal == "ar"
            ? "assist-list-ar"
            : "assist-list-en";
        } else {
          return this.currentLocal == "ar" ? "assist-ar" : "assist-en";
        }
      } else {
        return this.currentLocal == "ar" ? "converse-ar" : "converse-en";
      }
    },
    converseAccess() {
      return this.userHasPermisson(
        this.permissions,
        this.omniChannelPermission
      );
    },
    manageConverseAccess() {
      return this.userHasPermisson(
        this.permissions,
        this.ManageOmniChannelPermission
      );
    },
    notReadCount() {
      if (!this.notReadOmniMessages || this.notReadOmniMessages?.length == 0) {
        document.title = document.title.replace(/ *\([^)]*\) */g, "");
        return 0;
      } else {
        document.title =
          "(" +
          this.notReadOmniMessages?.length +
          ")" +
          document.title.replace(/ *\([^)]*\) */g, "");
        return this.notReadOmniMessages?.length;
      }
    },
    activeCount() {
      if (
        !this.omniActiveConversations ||
        this.omniActiveConversations?.length == 0
      ) {
        return 0;
      } else {
        return this.omniActiveConversations?.length;
      }
    },
  },
  methods: {
    ...mapActions(["SendMessageToAssistantBot", "SetMessageDialog"]),
    ...mapMutations([
      "setAssistantAsk",
      "setAssistantChat",
      "setOmniOpenedConversation",
    ]),
    handleConversationAccess(isOpen) {
      this.isOpen = isOpen;
      this.omniConverse = isOpen ? [this.omniExpansionValue] : [];
    },
    handleAssistantAccess(isOpen) {
      this.assistantOpen = isOpen;
      this.assistantConverse = isOpen ? ["open_assistant"] : [];
    },
  },
  watch: {
    // async assistantAsk(val) {
    //   if (!val || val?.type == 2) {
    //     return;
    //   }
    //   try {
    //     const resp = await this.SendMessageToAssistantBot({
    //       message: val.message,
    //       thread_id: this.assistantChat.thread_id
    //         ? this.assistantChat.thread_id
    //         : "",
    //     });
    //     const updatedMsgs = JSON.parse(
    //       JSON.stringify(this.assistantChat.messages)
    //     );
    //     const msgIdx = updatedMsgs.findIndex((msg) => msg.id == val.id);
    //     updatedMsgs[msgIdx].waiting = false;
    //     updatedMsgs[msgIdx].loading = false;
    //     if (!resp.success) {
    //       this.SetMessageDialog({ show: true, message: resp.message });
    //       updatedMsgs[msgIdx].failed = true;
    //       this.setAssistantChat({
    //         ...this.assistantChat,
    //         messages: updatedMsgs,
    //       });
    //       return;
    //     }
    //     updatedMsgs[msgIdx].failed = false;
    //     this.setAssistantChat({
    //       ...this.assistantChat,
    //       messages: updatedMsgs,
    //       thread_id: resp.thread_id,
    //     });
    //     if (this.assistantConverse.length > 0) {
    //       this.setAssistantAsk(resp.reply);
    //     } else {
    //       updatedMsgs.unshift(resp.reply);
    //       this.setAssistantChat({
    //         ...this.assistantChat,
    //         messages: updatedMsgs,
    //       });
    //     }
    //   } catch (err) {
    //     let message = err.message;
    //     if (err.response) {
    //       message = err.response.data.message;
    //     }
    //     const updatedMsgs = JSON.parse(
    //       JSON.stringify(this.assistantChat.messages)
    //     );
    //     const msgIdx = updatedMsgs.findIndex((msg) => msg.id == val.id);
    //     updatedMsgs[msgIdx].waiting = false;
    //     updatedMsgs[msgIdx].loading = false;
    //     updatedMsgs[msgIdx].failed = true;
    //     this.setAssistantChat({
    //       ...this.assistantChat,
    //       messages: updatedMsgs,
    //     });
    //     this.SetMessageDialog({ show: true, message: message });
    //   }
    // },
    notReadOmniMessages(newVal, oldVal) {
      // console.log("My notRaesMsggg", newVal, oldVal);
      if (!newVal) {
        return;
      }
      if (newVal?.length == 0) {
        clearInterval(this.omniNotificationTimer);
        this.omniNotificationTimer = null;
        return;
      }

      const msgIsRead = newVal?.length < oldVal?.length;

      if (msgIsRead) {
        clearInterval(this.omniNotificationTimer);
        this.omniNotificationTimer = null;
        this.omniNotificationTimer = setInterval(() => {
          this.handleConversationAccess(true);
        }, 60000);
        return;
      }

      const isOmniNotOpened =
        !this.omniConverse ||
        this.omniConverse?.length <= 0 ||
        this.omniConverse == this.omniExpansionValue;
      if (isOmniNotOpened) {
        this.handleConversationAccess(true);
      }
      if (!this.omniNotificationTimer) {
        this.omniNotificationTimer = setInterval(() => {
          this.handleConversationAccess(true);
        }, 60000);
      }
    },
    omniConverse(val) {
      // console.log(
      //   "watch omniConverse",
      //   val,
      //   val == this.omniExpansionValue,
      //   !val || val?.length <= 0 || val == this.omniExpansionValue,
      //   "openedConvvV",
      //   this.omniOpenedConversation
      // );
      if (!val || val?.length <= 0) {
        this.setOmniOpenedConversation(null);
      } else if (val?.length > 0 && val != this.omniExpansionValue) {
        if (this.omniNotificationTimer) {
          clearInterval(this.omniNotificationTimer);
          this.omniNotificationTimer = null;
          this.omniNotificationTimer = setInterval(() => {
            this.handleConversationAccess(true);
          }, 60000);
        }
      }
    },
    // assistantConverse(val) {
    //   if (val.length > 0 && this.omniConverse.length > 0) {
    //     this.omniConverse = [];
    //   }
    // },
  },
  unmounted() {
    clearInterval(this.omniNotificationTimer);
    this.omniNotificationTimer = null;
  },
};
</script>

<style scoped>
.converse-ar {
  left: 8%;
}
.converse-en {
  right: 8%;
}
.assist-ar {
  left: 22%;
}
.assist-en {
  right: 25%;
}
.assist-list-ar {
  left: 30%;
}
.assist-list-en {
  right: 30%;
}
.assist-open-ar {
  left: 50%;
}
.assist-open-en {
  right: 50%;
}
.titles {
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: 0.0125em;
}
.avatar-image {
  width: 100%; /* Ensures the image fills the avatar */
  height: 100%; /* Ensures the image fills the avatar */
  object-fit: contain; /* Adjusts to fit the whole image within the avatar */
  border-radius: 50%; /* Keeps the circular shape */
}
</style>
